import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { TokenDetails } from '../../interfaces/common'

interface CustomTokenStore {
  customTokens: { [key: string]: TokenDetails[] }
  addToken: (walletId: string, details: TokenDetails) => void
  removeToken: (walletId: string, canisterId: string) => void
}

export const createCustomTokensStore = (storage: StateStorage) =>
  createStore<CustomTokenStore>(
    storage,
    (set, get) => ({
      customTokens: {},
      addToken(walletId, details) {
        const { customTokens } = get()
        set({
          customTokens: {
            ...customTokens,
            [walletId]: [...(customTokens[walletId] || []), details],
          },
        })
      },
      removeToken(walletId, canisterId) {
        const { customTokens } = get()
        set({
          customTokens: {
            ...customTokens,
            [walletId]: (customTokens[walletId] || []).filter(
              (details) => details.principalId !== canisterId
            ),
          },
        })
      },
    }),
    {
      persist: {
        name: 'userTokens',
        version: 0,
      },
    }
  )
